import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="float-button"
export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 0.6 }
  }

  get clampedThreshold() {
    return Math.min(Math.max(this.thresholdValue, 0), 1)
  }

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const shouldShow = window.scrollY > window.innerHeight * this.clampedThreshold
    this.element.classList.toggle("is-visible", shouldShow)
  }
}
